<nav class="page-navbar navbar navbar-expand-md">
  <div class="d-flex col-12 align-items-center">
    <div class="metanav-container">
      <div class="navbar-brand-container">
        <a class="navbar-brand" (click)="goToHome($event)" href>{{
          model ? model.title : ''
        }}</a>
      </div>
    </div>
    <div class="nav-container d-flex mr-auto">
      <button
        class="navbar-toggler btn btn-outline-primary"
        type="button"
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseBasic"
      >
        <span class="navbar-toggler-icon oi oi-menu"></span>
      </button>
      <div
        class="collapse navbar-collapse"
        id="navbarMain"
        [collapse]="isCollapsed"
        [isAnimated]="true"
      >
        <ul
          class="navbar-nav d-flex justify-content-between"
          *ngIf="model && model.tabs"
        >
          <li
            class="nav-item btn-group"
            dropdown
            [routerLinkActive]="['active']"
            *ngFor="let tab of model.tabs"
          >
            <ng-container *ngIf="!tab.options && tab.show">
              <a
                [routerLink]="tab.link ? [tab.link] : ['']"
                class="nav-link btn btn-outline-primary"
                >{{ tab.name }}</a
              >
            </ng-container>
            <ng-container *ngIf="tab.options && tab.show">
              <div class="btn-group" dropdown>
                <button
                  id="button-basic"
                  dropdownToggle
                  type="button"
                  class="btn btn-outline-primary nav-link dropdown-toggle"
                  aria-controls="dropdown-basic"
                >
                  {{ tab.name }}
                </button>
                <ul
                  id="dropdown-basic"
                  *dropdownMenu
                  class="dropdown-menu"
                  role="menu"
                  aria-labelledby="button-basic"
                >
                  <li
                    role="menuitem"
                    class="nav-item"
                    [routerLinkActive]="['active']"
                    *ngFor="let option of tab.options"
                  >
                    <a [routerLink]="[option.link]" class="nav-link">{{
                      option.name
                    }}</a>
                  </li>
                </ul>
              </div>
            </ng-container>
          </li>
        </ul>
      </div>
    </div>

    <div class="metanav" [collapse]="isCollapsed" [isAnimated]="true">
      <form class="d-flex align-items-center justify-content-end">
        <div
          class="btn-darkmode hidden"
          *ngIf="showDarkMode()"
          (click)="switchDarkmode()"
        >
          <div class="btn-round"></div>
          <div class="btn-darkmode-background"></div>
        </div>
        <button
          *ngIf="!isAuthenticated"
          (click)="onLogin()"
          type="button"
          class="btn"
        >
          <span
            class="oi oi-lock-unlocked"
            tooltip="Log in"
            placement="bottom"
          ></span>
        </button>
        <button
          *ngIf="isAuthenticated && model.showDocumentation"
          (click)="onOpenDocumentation()"
          type="button"
          class="btn"
        >
          <rr-questionmark-circel-icon></rr-questionmark-circel-icon>
        </button>
        <button
          *ngIf="showProfile()"
          type="button"
          [routerLink]="[model.profile.link]"
          class="btn"
        >
          <span
            class="oi oi-person"
            tooltip="Profile"
            placement="bottom"
          ></span>
        </button>
        <div *ngIf="showResetOptions()" class="clear-cache-container">
          <div class="clear-cache-title">
            <button
              type="button"
              (click)="onResetStorageClick('everything')"
              class="btn"
            >
              <span
                class="oi oi-flash"
                tooltip="Clear All Caches"
                placement="left"
              ></span>
            </button>
          </div>
          <div class="clear-cache-dropdown">
            <button
              type="button"
              (click)="onResetStorageClick('local')"
              class="btn"
            >
              <span
                class="oi oi-flash"
                tooltip="Clear Settings"
                placement="left"
              ></span>
            </button>
            <button
              type="button"
              (click)="onResetStorageClick('session')"
              class="btn"
            >
              <span
                class="oi oi-flash"
                tooltip="Clear Dropdowns"
                placement="left"
              ></span>
            </button>
          </div>
        </div>
        <button
          *ngIf="isAuthenticated"
          (click)="onLogout()"
          type="button"
          class="btn"
        >
          <span
            class="oi oi-lock-locked"
            tooltip="Log out"
            placement="bottom"
          ></span>
        </button>
      </form>
    </div>
  </div>
</nav>
